import {newEntityStoreHelper} from "@/store/common/entityModule";
 
export default newEntityStoreHelper(() => {}, () => {})
    .withStates({
        selectItems: [],
        baseModuleUrl : process.env.VUE_APP_ADM_API_URL + "adm-service/adm"
    })
    .withActions({
        retrieveForSelect(context) {
            context.dispatch("api/get", {
                url : (context.state.baseModuleUrl +"/integrationMessageDefinition/findToComboBox")
            }, {root: true})
            .then(function(data) {
                var result = data.map(x => { return {value: x.id, text: x.name} })
                context.commit("messageType/setSelectItens", result, {root: true})
            })
        }
    })
    .withMutations({
        setSelectItens(state, data) {
            state.selectItems = data
        }
    })
    .buildStore()